import { render, staticRenderFns } from "./BusinessDetailView.vue?vue&type=template&id=3560fe5b&scoped=true"
import script from "./BusinessDetailView.vue?vue&type=script&lang=js"
export * from "./BusinessDetailView.vue?vue&type=script&lang=js"
import style0 from "./BusinessDetailView.vue?vue&type=style&index=0&id=3560fe5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3560fe5b",
  null
  
)

export default component.exports